import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

// Beautiful gradient progress bar shown at the top of the streak popup.
const StreakProgress = ({ currentDay = 0, totalDays = 0, claimed = false }) => {
  const { t } = useTranslation();
  if (!totalDays) return null;

  // Progress reflects days actually claimed. If the current day isn't claimed
  // yet (e.g. day 1 not claimed), that day doesn't count -> claimedDays - 1.
  const claimedDays = Math.max(0, claimed ? currentDay : currentDay - 1);
  const pct = Math.min(100, Math.round((claimedDays / totalDays) * 100));
  const remaining = Math.max(0, totalDays - claimedDays);

  return (
    <Box
      sx={{
        mb: 3,
        p: { xs: 2, md: 2.5 },
        borderRadius: 3,
        background:
          "linear-gradient(135deg, rgba(255,255,255,0.12), rgba(255,255,255,0.04))",
        border: "1px solid rgba(255,255,255,0.15)",
        backdropFilter: "blur(6px)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
        }}
      >
        <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "14px" }}>
          {t('streak.progressDayOf', { current: currentDay, total: totalDays })}
        </Typography>
        <Typography
          sx={{
            fontWeight: 800,
            fontSize: "16px",
            background: "linear-gradient(90deg, #ffd54a, #ff7a00)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {pct}%
        </Typography>
      </Box>

      {/* Track */}
      <Box
        sx={{
          position: "relative",
          height: 12,
          borderRadius: 6,
          background: "rgba(0,0,0,0.35)",
          overflow: "hidden",
          boxShadow: "inset 0 1px 3px rgba(0,0,0,0.4)",
        }}
      >
        {/* Fill */}
        <Box
          sx={{
            position: "absolute",
            left: 0,
            top: 0,
            height: "100%",
            width: `${pct}%`,
            borderRadius: 6,
            background: "linear-gradient(90deg, #ff7a00, #ff3d8b 55%, #9d6bff)",
            boxShadow: "0 0 12px rgba(255,61,139,0.7)",
            transition: "width 0.6s cubic-bezier(0.4,0,0.2,1)",
          }}
        />
      </Box>

      <Typography
        sx={{ color: "#e3f2fd", fontSize: "12px", mt: 1, fontWeight: 600 }}
      >
        {pct >= 100
          ? t('streak.progressComplete')
          : remaining <= 1
          ? t('streak.progressFinalDay')
          : t('streak.progressAlmostThere', { remaining })}
      </Typography>
    </Box>
  );
};

export default StreakProgress;
